<script>
  import CuratedByListTreatment from './CuratedByListTreatment.svelte';

  export let index;
  export let shortlink;
  export let imageUrl;
  export let isList;
  export let previewMode;
</script>

<!-- 
  The target="_blank" here is actually being overridden by a <svelte:window>
  script that is changing the on-click behavior for anchor tags. The html is
  left this way so that way users still expect to be opened in a new tab.
-->
<a
  id={index != null ? `scroll-item-${index}` : undefined}
  class="relative flex h-[95px] w-full cursor-pointer items-center justify-center rounded bg-[#F9F9F9]"
  href={previewMode ? null : shortlink}
  target="_blank"
>
  {#if isList}
    <CuratedByListTreatment classes="absolute inset-0 z-0 p-1" />
    <img
      class="z-10 h-[65%] max-h-[65%] w-[65%] max-w-[65%] origin-center object-contain mix-blend-multiply transition-all hover:-translate-y-1 hover:scale-110"
      src={imageUrl}
    />
  {:else}
    <img
      class="z-10 h-[70%] max-h-[70%] w-[70%] max-w-[70%] origin-center object-contain mix-blend-multiply transition-all hover:-translate-y-1 hover:scale-110"
      src={imageUrl}
    />
  {/if}
</a>
